import * as path from 'node:path';
import { normalizeResolvedPath } from '../../paths/normalize-resolved-path.js';

/**
 * **Bridge root**: directory the bridge uses for git repos, skills, file index, and `bridge_root` sessions.
 * Defaults to where the CLI was started, then `process.chdir` from `--bridge-root` / legacy `--cwd`.
 *
 * Call {@link initBridgeRoot} once at startup after applying those options so all bridge paths agree.
 */
let bridgeRootPath: string | null = null;

/** Capture `process.cwd()` after startup / `chdir` (idempotent). */
export function initBridgeRoot(): void {
  bridgeRootPath = normalizeResolvedPath(process.cwd());
}

/**
 * Absolute bridge root. Prefer {@link initBridgeRoot} at startup; otherwise falls back to `process.cwd()`
 * (e.g. tests).
 */
export function getBridgeRoot(): string {
  if (bridgeRootPath == null) {
    bridgeRootPath = normalizeResolvedPath(process.cwd());
  }
  return bridgeRootPath;
}

/** Test-only: clear cached bridge root so `initBridgeRoot` can rebind cwd. */
export function resetBridgeRootForTests(): void {
  bridgeRootPath = null;
}
